import { Component, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import { CreateElement } from 'vue'

import { Element } from '@src/mixins/element/element'

import './textarea.sass'

@Component
export class Textarea extends Mixins<Element>(Element) {

  @Prop({ required: false })
  value: string

  @Prop({ required: false })
  readonly: boolean

  @Prop({ required: false })
  change: (value: string) => void

  @Prop({ required: false })
  keyup: (value: string) => void

  @Prop({ required: false })
  maxLength: number

  @Prop({ required: false })
  placeholder: string

  hasFocus: boolean = false

  readonlyInflictedByParent: boolean = false

  // what is typed while the textarea has the focus: vue sets the value of the textarea on every render, and the
  // parent only takes the text on change or keyup, so a render while typing (like the one for the focus itself)
  // would clear the text
  typedValue: string = ''

  mounted () {
    let wizard: HTMLElement | null = document.getElementById('wizard-content')

    if (wizard && wizard.classList.contains('readonly')) {
      this.readonlyInflictedByParent = true
    }
  }

  render (h: CreateElement) {
    let styleClasses = [
      ...this.elementStyles,
      ...this.inputStyles
    ]

    return (
      this.renderElement(h, styleClasses, this.disabled, [
        this.renderTextArea(h, this.disabled)
      ])
    )
  }

  protected renderTextArea (h: CreateElement, disabled: boolean) {
    return <div class='textarea-container'>
      <textarea ref='textarea' value={this.hasFocus ? this.typedValue : this.value} placeholder={this.label ? '' : this.placeholder}
                onFocus={this.onFocus} onInput={this.onInput} onKeyup={this.onKeyup} onBlur={this.onFocus} onChange={this.onChange}
                disabled={disabled} readonly={this.readonly || this.readonlyInflictedByParent}
                maxlength={this.maxLength}
                onPaste={this.onPaste}
      />
      {this.label ? <label class='input-description'>{this.label}</label> : ''}
    </div>
  }

  protected get inputStyles () {
    let styleClasses = ['textarea']

    if (this.hasFocus) {
      styleClasses.push('focus')
    }

    if (this.value) {
      styleClasses.push('valid')
    }

    return styleClasses
  }

  protected onFocus (event: FocusEvent) {
    this.typedValue = (event.target as HTMLTextAreaElement).value
    this.hasFocus = (!this.readonly && !this.readonlyInflictedByParent) && (event.target === document.activeElement)
  }

  protected onInput ($event) {
    this.typedValue = $event.target.value
  }

  protected onChange ($event) {
    if (this.change) {
      this.change($event.target.value)
    }
  }

  protected onKeyup ($event) {
    if (this.keyup) {
      this.keyup($event.target.value)
    }
  }

  protected onPaste ($event) {
    setTimeout(() => {
      this.onKeyup($event)
      this.onChange($event)
    }, 100)
  }
}
